import * as React from 'react';
import BCButton from '../BCButton';
import BCInput from '../BCInput';
import { BCSpaceCompact } from '../BCSpace';
import BCPopover from '../BCPopover';
import { IDropdownBoxProps } from './entities';
import IconMore from '@bimser/icons/16/more2';

const inputStyle: React.CSSProperties = { width: 'calc(100% - 50px)' };
const buttonStyle: React.CSSProperties = { width: '50px' };
const displayNone: React.CSSProperties = { display: 'none' };

const BCDropdownBox = (props: IDropdownBoxProps) => (
	<BCPopover
		title={props.title}
		content={props.content}
		trigger="click"
	>
		<>
			<BCSpaceCompact
				size={props.size}
				block
			>
				<BCInput
					style={inputStyle}
					readOnly
					value={props.value}
					tabIndex={props.tabIndex}
				/>
				<BCButton
					style={buttonStyle}
					icon={<IconMore />}
				/>
			</BCSpaceCompact>
			<BCButton style={displayNone}></BCButton>
		</>
	</BCPopover>
);
export default BCDropdownBox;
